import SEO from "../../../../src/components/seo";
import Navigation from "../../../../src/components/navigation";
import { Settings } from "../../../../src/components/Settings";
import React from 'react';
export default {
  SEO,
  Navigation,
  Settings,
  React
};